import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box, Typography } from '@lyearn/ui';

import ManagerSearch from './ManagerSearch';
import { ReportingManagerProps } from './types';

function ReportingManager({
  reportsToUserId,
  onChange,
  user: learner,
  error,
}: ReportingManagerProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography className="mb-8 ms-8" variant="body-short-02">
        {t('Admin:InviteStaff.ReportsTo')}
      </Typography>
      <ManagerSearch
        defaultUser={learner?.manager as any}
        error={error}
        excludedUsers={[learner.id]}
        initalValue={learner?.manager?.name}
        reportsToUserId={reportsToUserId}
        onChange={onChange}
      />
      {error && (
        <Typography className="mt-8" color="text-text-error" variant="body-short-03">
          {t('LearnerProfile:ReporteeManagerError')}
        </Typography>
      )}
    </Box>
  );
}

export default ReportingManager;
